//@flow

import invariant from './invariant';

function abstractMethod<T>(className: string, methodName: string): T {
  invariant(
    false,
     'Subclasses of %s must override %s() with their own implementation.',
     className,
     methodName
   );
}



// WEBPACK FOOTER //
// ./sdk/scripts/utils/abstractMethod.js